import React from 'react';
import { MainSectionButtons } from './components/MainSectionButtons';
import {
  BodyWrapper, BodyHeader, BodyParagraph, SectionButtonsWrapper,
} from '../../../../view/Banner/Banner';

export function MainSectionBody(): JSX.Element {
  return (
    <BodyWrapper>
      <BodyHeader as="h1">
        Poznajmy się
      </BodyHeader>
      <BodyParagraph>
        <>
          Od pokoleń zajmujemy się uprawą owoców i warzyw. Nasze gospodarstwo to przede
          wszystkim tradycyjne odmiany owoców, które uprawiamy ekologicznie. Z jego plonów
          tworzymy naturalne przetwory.
          Używamy starych, sprawdzonych receptur, a przetwory robimy domowo,
          żeby zachować właściwości prozdrowotne owoców, warzyw i ziół.
        </>
      </BodyParagraph>
      <SectionButtonsWrapper>
        <MainSectionButtons />
      </SectionButtonsWrapper>
    </BodyWrapper>
  );
}
